import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import SessionStorage from '../util/sessionstore'
import { message } from 'antd'
import FileSaver from 'file-saver'
import Axios from 'axios'
import _ from 'lodash'
import util from '../util/util'
import moment from 'moment'

const session = new SessionStorage()
const service = new ApolloClientService()

export default class Patient {
  getPatientList = (param) => {
    return new Promise((resolve, reject) => {
      let input = {
        ...param,
        sorter: {
          order: param.sorter?.order,
          field: param.sorter?.field,
        },
      }
      service
        .getPatientList(input)
        .then((data) => {
          let metadata = JSON.parse(JSON.stringify(input.metadata))
          metadata.total = data.total
          resolve({
            metadata,
            patients: data.patients,
          })
        })
        .catch((err) => reject(err))
    })
  }

  getPatientListForCompany = (param) => {
    return new Promise((resolve, reject) => {
      let input = {
        ...param,
        sorter: {
          order: param.sorter?.order,
          field: param.sorter?.field,
        },
      }
      service
        .getPatientListForCompany(input)
        .then((data) => {
          let metadata = JSON.parse(JSON.stringify(input.metadata))
          metadata.total = data.total
          resolve({
            patients: data.patients,
          })
        })
        .catch((err) => reject(err))
    })
  }

  getRegisteredPatients = (param) => {
    return new Promise((resolve, reject) => {
      let input = param
      service
        .getRegisteredPatients(input)
        .then((data) => {
          let metadata = JSON.parse(JSON.stringify(input.metadata))
          metadata.total = data.total
          resolve({
            patients: data.patients,
            metadata,
          })
        })
        .catch((err) => reject(err))
    })
  }

  deleteRegisteredPatient = (param) => {
    return new Promise((resolve, reject) => {
      let input = param
      service
        .deleteRegisteredPatient(input)
        .then((data) => {
          resolve({
            patients: data.patients,
          })
        })
        .catch((err) => reject(err))
    })
  }

  downloadReport = (patientid, newTab) => {
    console.log('downloadReport', patientid)
    return new Promise((resolve, reject) => {
      Axios.post(
        constants.API_URL + '/downloadreport',
        //constants.LINK+"/downloadreport",
        { data: { id: patientid } },
        {
          responseType: 'blob',
          headers: { 'x-authorization': 'Bearer ' + session.getProfile()?.token },
        }
      )
        .then((response) => {
          if (!newTab) {
            resolve(response)
            FileSaver.saveAs(response.data, `${patientid}.pdf`)
          } else {
            resolve(response)
            var url = URL.createObjectURL(response.data)
            window.open(url, '_blank')
          }
        })
        .catch((err) => {
          message.info('Not enough data available to generate report.')
          resolve(err)
        })
    })
  }

  // Signed consent PDFs. These used to arrive in support's inbox as email
  // attachments; they are now fetched here, where the request is authenticated,
  // scoped to the clinician's clinic, and audited server-side as
  // `consent.download`. docs/PLAN_MINIMIZE_PHI_IN_EMAIL.md
  //
  // A patient signs one PDF per consent form, so ask what exists before
  // downloading — the caller shows one link or several.
  listConsentDocuments = (patientid) => {
    return Axios.get(
      constants.API_URL + `/consent/${patientid}/documents`,
      {
        headers: { 'x-authorization': 'Bearer ' + session.getProfile()?.token },
      }
    ).then((response) => response.data)
  }

  downloadConsent = (patientid, index = 0, filename) => {
    return Axios.get(
      constants.API_URL + `/consent/${patientid}/pdf/${index}`,
      {
        responseType: 'blob',
        headers: { 'x-authorization': 'Bearer ' + session.getProfile()?.token },
      }
    ).then((response) => {
      FileSaver.saveAs(response.data, filename || `consent-${patientid}.pdf`)
      return response
    })
  }

  sendNotifications = (params) => {
    return new Promise((resolve, reject) => {
      service
        .sendNotifications(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getPatientsFourdigits = () => {
    return new Promise((resolve, reject) => {
      service
        .getPatientsFourdigits()
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  caregiverNotify = (caregiver) => {
    return new Promise((resolve, reject) => {
      service
        .caregiverNotify(caregiver)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  sendMail = (params) => {
    return new Promise((resolve, reject) => {
      service
        .sendMail(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getPatientStats = (customerid) => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      let id = ''
      if (profile.customer?._id) id = profile.customer?._id
      else id = customerid
      service
        .getPatientStats({ customerid: id })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  getPatientCompliance = (data, customerid) => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      let id = ''
      if (profile.customer?._id) id = profile.customer?._id
      else id = customerid

      service
        .getPatientCompliance({ ...data, id })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getPatientComplianceExercise = (data, customerid) => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      let id = ''
      if (profile.customer?._id) id = profile.customer?._id
      else id = customerid

      service
        .getPatientComplianceExercise({ ...data, id })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  getPatientComplianceMeasurement = (data, customerid) => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      let id = ''
      if (profile.customer?._id) id = profile.customer?._id
      else id = customerid

      service
        .getPatientComplianceMeasurement({ ...data, id })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  getPatientComplianceFeedback = (data, customerid) => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      let id = ''
      if (profile.customer?._id) id = profile.customer?._id
      else id = customerid

      service
        .getPatientComplianceFeedback({ ...data, id })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = 'Service Error'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  getPatient = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getPatient(id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
getActiveAssignedDevices= (id) => {
    return new Promise((resolve, reject) => {
      service
        .getActiveAssignedDevices(id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  getexercompletecount(schedule) {
    return schedule.exercises.reduce((p, item) => {
      return p + (item.status ? 1 : 0)
    }, 0)
  }

  getdevcompletecount(schedule) {
    return schedule.devices.reduce((p, item) => {
      return (
        p +
        item.timesheet.reduce((c, ts) => {
          return c + (ts.status ? 1 : 0)
        }, 0)
      )
    }, 0)
  }

  // TracPatch is handled differently from Tenovi-class measurement devices: its
  // "measurement" is the Progress Test (active ROM) which is recorded outside
  // the device timesheet, so timesheet.status never flips true. We detect a
  // TracPatch device by display_name/device_type (mirrors the check used in
  // pages/activities/activities.js).
  isTracPatchDevice(device) {
    if (!device) return false
    var name = (device.display_name || '').toLowerCase()
    var type = (device.device_type || '').toLowerCase()
    return name.includes('tracpatch') || type === 'tracpatch'
  }

  // A TracPatch measurement counts as done for a day when the patient completed
  // a Progress Test that day — i.e. an active ROM test with both Extension and
  // Flexion recorded. Passive sensor readings (is_rom_test !== true) don't count.
  hasRomTestForDay(romTests, date) {
    if (!Array.isArray(romTests) || !date) return false
    return romTests.some((r) => {
      if (!r || !r.is_rom_test) return false
      if (r.extension == null || r.flexion == null) return false
      var when = r.startTime || r.endTime
      return when && moment(when).isSame(moment(date), 'day')
    })
  }

  getformcompletecount(forms) {
    return forms.reduce((p, item) => {
      return p + (item.meta.complete ? 1 : 0)
    }, 0)
  }

  getExerciseStatus({ date, schedules }) {
    var schedule = _.find(schedules, (v, i) => util.isSame(v.date, date))
    if (!schedule) return false
    var count = this.getexercompletecount(schedule),
      length = schedule.exercises.length
    var percent = Math.round((count / length) * 100)
    if (count == length) return { complete: true, percent }
    if (count < length && count > 0) return { partial: true, percent }
    if (count == 0 && util.isAfter(schedule.date, new Date()))
      return { incomplete: true, percent }
    if (count == 0 || (count == 0 && util.isSame(new Date(), schedule.date)))
      return { remaining: true, percent }
  }

  getMeasurmentStatus({ date, deviceSchedules, romTests }) {
    var schedule = _.find(deviceSchedules, (v, i) => {
      return util.isSame(moment(v.date).format('MM/DD/YYYY'), date)
    })
    if (!schedule) return false
    // A completed Progress Test that day marks every TracPatch measurement slot
    // as done; Tenovi devices keep using their timesheet.status as before.
    var romDone = this.hasRomTestForDay(romTests, schedule.date)
    var count = 0
    var length = 0
    schedule.devices.forEach((item) => {
      var slots = item.timesheet ? item.timesheet.length : 0
      if (this.isTracPatchDevice(item) && romDone) {
        // Guarantee 100% for the TracPatch device even if it has no scheduled
        // timesheet slot (once-a-day devices still carry one, but be safe).
        var eff = Math.max(slots, 1)
        length += eff
        count += eff
      } else {
        length += slots
        count += item.timesheet
          ? item.timesheet.reduce((c, ts) => c + (ts.status ? 1 : 0), 0)
          : 0
      }
    })
    if (length == 0) return false
    var percent = Math.round((count / length) * 100)
    if (count == length) return { complete: true, percent }
    if (count < length && count > 0) return { partial: true, percent }
    if (count == 0 && util.isAfter(schedule.date, new Date()))
      return { incomplete: true, percent }
    if (count == 0 || (count == 0 && util.isSame(new Date(), schedule.date)))
      return { remaining: true, percent }
  }

  getEvent({ date, schedules }) {
    var schedule = _.filter(schedules, (v, i) => util.isSame(v.date, date))
    if (schedule.length == 0) return false
    return schedule
  }

  getFeed({ date, schedules }) {
    var schedule = _.find(schedules, (v, i) => util.isSame(v.date, date))
    if (!schedule) return false
    return schedule?.forms
  }
  getLastForm({ formtype, schedules }) {
    var schedule = null
    schedules.forEach((e) => {
      if (
        moment().startOf('day').isSameOrAfter(moment(e.date).startOf('day'))
      ) {
        console.log(e.date, e)
        e.forms.forEach((i) => {
          if (i.meta.complete && i.meta.name == formtype) schedule = e
        })
      }
    })
    if (!schedule) return false
    return schedule
  }
  getAllForm({ formtype, schedules }) {
    schedules = _.sortBy(schedules, (item) => new Date(item.date))
    var schedule = []
    schedules.forEach((e) => {
      if (
        moment().startOf('day').isSameOrAfter(moment(e.date).startOf('day'))
      ) {
        e.forms.forEach((i) => {
          if (i.meta.complete && i.meta.name == formtype) {
            schedule.push({ ...i, date: e.date })
          }
        })
      }
    })
    return schedule
  }

  getExercises = ({ date, schedules }) => {
    var schedule = _.find(schedules, (v, i) => util.isSame(v.date, date))
    if (!schedule) return false
    return schedule.exercises
  }

  getDevices = ({ date, schedules }) => {
    var schedule = _.find(schedules, (v, i) => util.isSame(v.date, date))
    if (!schedule) return false
    return schedule.devices
  }

  getFormStatus(forms, date) {
    var count = this.getformcompletecount(forms),
      length = forms.length
    var percent = length ? Math.round((count / length) * 100) : 0
    if (count == length) return { complete: true, percent }
    if (count < length && count > 0) return { partial: true, percent }
    if (count == 0 && util.isAfter(date, new Date()))
      return { incomplete: true, percent }
    if (count == 0 || (count == 0 && util.isSame(new Date(), date)))
      return { remaining: true, percent }
  }

  getOksData = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getOksData(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getKoosJrData = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getKoosJrData(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getHoosJrData = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getHoosJrData(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getPainData = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getPainData(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getPainLevelData = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getPainLevelData(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getFlexionData = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getFlexionData(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getExtensionData = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getExtensionData(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getTracPatchROM = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getTracPatchROM(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getTracPatchSteps = (id, startDate, endDate) => {
    return new Promise((resolve, reject) => {
      service
        .getTracPatchSteps(id, startDate, endDate)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getTracPatchTemperature = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getTracPatchTemperature(id)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  getTracpatchExerciseResults = (id, exerciseId, startDate, endDate) => {
    return new Promise((resolve, reject) => {
      service
        .getTracpatchExerciseResults(id, exerciseId, startDate, endDate)
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  }

  addEvent = (id, event, state) => {
    return new Promise((resolve, reject) => {
      service
        .addEvent(id, event)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            var patient = this.addEventToState(state, event)
            resolve(patient)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  editShipAddress = (id, input, state) => {
    return new Promise((resolve, reject) => {
      service
        .editShipAddress({ _id: id, ...input })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            var patient = this.addShipaddressToState(state, input)

            resolve(patient)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  editcaregiver = (id, input, state) => {
    return new Promise((resolve, reject) => {
      service
        .editcaregiver({ _id: id, ...input })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            var patient = this.addCaregiverToState(state, input)
            resolve(patient)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  edithealthcoach = (patientid, healthcoachid) => {
    return new Promise((resolve, reject) => {
      service
        .edithealthcoach(patientid, healthcoachid)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  addEventToState = (state, event) => {
    var patient = JSON.parse(JSON.stringify(state))
    patient.eventSchedule.push(event)
    patient.eventSchedule = _.orderBy(patient.eventSchedule, ['date'], ['asc'])
    return patient
  }

  addCaregiverToState = (state, data) => {
    var patient = JSON.parse(JSON.stringify(state))
    patient.caregiver = data
    return patient
  }
  addShipaddressToState = (state, data) => {
    var patient = JSON.parse(JSON.stringify(state))
    patient.shipaddress = data
    return patient
  }

  getForm = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getFormByScheduleSubId(id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  addPatient = (input) => {
    return new Promise((resolve, reject) => {
      service
        .addPatient(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  validatePatient = (input) => {
    return new Promise((resolve, reject) => {
      service
        .validatePatient(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  editPatient = (input, id) => {
    return new Promise((resolve, reject) => {
      service
        .editPatient(input, id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getLast7Activities = (customerid, date) => {
    return new Promise((resolve, reject) => {
      service
        .getLast7Activities(customerid, date)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getLast7Measurements = (customerid, date) => {
    return new Promise((resolve, reject) => {
      service
        .getLast7Measurements(customerid, date)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getFormatedDev = (devices=[]) => {
    const d = devices.map((e) => {
      try{
      delete e.isNew
      delete e.__typename
      delete e.media.__typename
      delete e.media.image.__typename
      delete e.scheduled_criteria?.__typename
        return e
    }
    catch(err){
        console.log("Format device err",err)
        return e
    }
    })

    return d
  }

  getFormatedForms = (forms) => {
    const d = forms.map((e) => {
      try{
      delete e.__typename
      delete e._id
      if (!e.schedule && e.weekdays) {
        e.schedule = e.weekdays.map(
          (i) => _.find(constants.WEEKDAYS, { name: i })?.index
        )
      }
      if (!e.scheduletype) e.scheduletype = 'weekly'
      delete e.index
      delete e.shortname
      delete e.image
      delete e.editnew
      delete e.questions
      return e
    }
    catch(err){
      return e
    }
    })

    return d
  }

  getFormatedExer = (exercises) => {
    return exercises.map((e) => {
     try{
      delete e.__typename
      delete e.exercise.__typename
      // `exercise` is sent as GraphQL `ExerciseIn`, which has no `surgeryTypes`
      // field (only `surgeryTypeIds`). The Exercise query returns populated
      // `surgeryTypes`, so drop it before save or the mutation 400s with
      // "Field surgeryTypes is not defined by type ExerciseIn".
      if (e.exercise) delete e.exercise.surgeryTypes
      return e
    }
     catch (err) {
       return e
    }
    })
  }

  addCustomPatient = ({ patient, devices, exercises, feedback }) => {
    return new Promise((resolve, reject) => {
      console.log('OUY', exercises, feedback)
      const dev = this.getFormatedDev(devices)
      service
        .addCustomPatient({
          patient,
          devices: this.getFormatedDev(devices),
          exercises: this.getFormatedExer(exercises),
          feedback: this.getFormatedForms(feedback),
        })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  addRegisterPatient = (input) => {
    return new Promise((resolve, reject) => {
      delete input.regid
      service
        .addRegisterPatient(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  getActivityLog = (input) => {
    return new Promise((resolve, reject) => {
      service
        .getActivityLog(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  getConsentForm = (input) => {
    return new Promise((resolve, reject) => {
      service
        .getConsentForm(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getNotification = (_id) => {
    return new Promise((resolve, reject) => {
      service
        .getPatientNotifications({ _id })
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            if (!data) resolve({ error: true, message: 'No data' })
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  getExercise = (exerciseId) => {
    return new Promise((resolve, reject) => {
      service
        .getExercise(exerciseId)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }

  // Patient Diagnoses Methods
  getPatientDiagnoses = (patientId) => {
    return new Promise((resolve, reject) => {
      service
        .getPatientDiagnoses(patientId)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }

  addSingleDiagnosis = (patientId, input) => {
    return new Promise((resolve, reject) => {
      service
        .addSingleDiagnosis(patientId, input)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }

  updatePatientDiagnosis = (patientId, input) => {
    return new Promise((resolve, reject) => {
      service
        .updatePatientDiagnosis(patientId, input)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }

  deletePatientDiagnosis = (patientId, dxCode) => {
    return new Promise((resolve, reject) => {
      service
        .deletePatientDiagnosis(patientId, dxCode)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }

  addPatientDiagnoses = (input) => {
    return new Promise((resolve, reject) => {
      service
        .addPatientDiagnoses(input)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }

  getWoundImages = (patientid) => {
    return new Promise((resolve, reject) => {
      service
        .getWoundImages(patientid)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }

  getWoundImagesCount = (patientid) => {
    return new Promise((resolve, reject) => {
      service
        .getWoundImagesCount(patientid)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }
}
